import { render, staticRenderFns } from "./JDate.vue?vue&type=template&id=c32dae52"
import script from "./JDate.vue?vue&type=script&lang=js"
export * from "./JDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c32dae52')) {
      api.createRecord('c32dae52', component.options)
    } else {
      api.reload('c32dae52', component.options)
    }
    module.hot.accept("./JDate.vue?vue&type=template&id=c32dae52", function () {
      api.rerender('c32dae52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/JDate.vue"
export default component.exports